export default "__VITE_ASSET__Bwu9egje__"